import React, { useState, useEffect } from "react";
import {
  Table,
  Empty,
  Row,
  Col,
  Drawer,
  notification,
  Popconfirm,
  Button,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import MonthlyPlanTypeUpdate from "../Forms/MonthlyPlanTypeUpdate";
import MonthlyPlanTypeAdd from "../Forms/MonthlyPlanTypeAdd";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";

const openNotificationWithIconDelete = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Silme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};
const openNotificationWithIconWarningDelete = (type) => {
  notification[type]({
    message: "HATA",
    description: "Silme işlemi sırasında bir hata oluştu.",
    duration: 2,
  });
};

const MonthlyPlan = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-device-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });

  const [monthlyPlans, setMonthlyPlans] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [dataState, setDataState] = useState([{ skip: 0, take: 10 }]);
  const [monthlyPlanTypeId, setMonthlyPlanTypeId] = useState("");
  const [Name, setName] = useState("");
  const [take, setTake] = useState(20);
  const [skip, setSkip] = useState(0);
  const [visible, setVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);

  useEffect(() => {

    setMonthlyPlans({
      ...monthlyPlans,
      loading: true,
    });
    RequestHandler.get(`/MonthlyPlanType?$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setMonthlyPlans({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  }, [setDataState, setMonthlyPlans, setSkip, setTake, skip, take]);

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/MonthlyPlanType/getbyid/${value}`).then((response) => {
      setName(response.name);
      setMonthlyPlanTypeId(value);
      setVisibleUpdate(true);
    });
  };

  const onClose = () => {
    setVisibleUpdate(false);
    setVisible(false);
  };

  const reList = () => {
    setMonthlyPlans({
      ...monthlyPlans,
      loading: true,
    });

    RequestHandler.get(`/MonthlyPlanType?$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setMonthlyPlans({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getData = (val) => {
    if (val === "success") {
      reList();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };

  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };

  const handleDelete = (key) => {
    RequestHandler.delete(`/MonthlyPlanType?id=${key}`, undefined, false, { rawResponse: true }).then((res) => {
      if (res.status == 204 || res.status == 200) {
        openNotificationWithIconDelete("success");
        setMonthlyPlans({
          data: monthlyPlans.data.filter((item) => item.id !== key),
          total: monthlyPlans.total - 1,
          loading: false,
        });
        if (monthlyPlans.data.filter((item) => item.id !== key).length == 0) {
          window.location.reload();
        }
      } else {
        openNotificationWithIconWarningDelete("error");
      }
    });
  };

  const paging = (p) => {
    setDataState((prevState) => {
      prevState.skip = (p.current - 1) * 20;
      setSkip(prevState.skip);
      setTake(p.pageSize);
      return {
        prevState,
      };
    });
  };

  const columns = [
    {
      title: "Tip Adı",
      dataIndex: "name",
      width: "1%",
      key: "name",
    },
    {
      title: "",
      dataIndex: "operation",
      width: "10%",
      align: "right",
      render: (text, record) =>
        monthlyPlans.data.length >= 1 && !["Diğer","Çek","Senet"].includes(record.name) ? (
          <a
            onClick={() => {
              showDrawerUpdate(record.id);
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : null,
    },
    {
      title: "",
      dataIndex: "operation",
      width: "1%",
      render: (text, record) =>
        monthlyPlans.data.length >= 1 && !["Diğer","Çek","Senet"].includes(record.name) ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleDelete(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <div>
      <Row>
        {isTabletOrMobileDevice && (
          <>
            <Col span={13}>
              <p style={{ fontSize: "110%" }}>
                <BarsOutlined /> AYLIK PLAN TİPLERİ
              </p>
              <hr></hr>
              <br></br>
            </Col>
            <Col span={11}>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Aylık Plan Tipi Ekle
              </Button>
            </Col>
          </>
        )}
        {isDesktopOrLaptop && (
          <>
            <Col span={20}>
              <p style={{ fontSize: "120%", marginTop: -9 }}>
                <BarsOutlined /> AYLIK PLAN TİPLERİ
              </p>
            </Col>
            <Col span={4}>
              <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Aylık Plan Tipi Ekle
              </Button>
            </Col>
          </>
        )}
      </Row>
      <Drawer
        title="Aylık Plan Tipi Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <MonthlyPlanTypeUpdate
          key={monthlyPlanTypeId}
          Name={Name}
          sendDataForUpdate={getData}
          MonthlyPlanTypeId={monthlyPlanTypeId}
        />
      </Drawer>
      <Drawer
        title="Aylık İşlem Tipi Ekle"
        width={241}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <MonthlyPlanTypeAdd />
      </Drawer>
      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col span={2}></Col>
            <Col span={20}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  pageSizeOptions: ["15", "25", "50", "100"],
                  defaultPageSize: take,
                  total: monthlyPlans.total,
                }}
                dataSource={monthlyPlans.data}
                loading={monthlyPlans.loading}
              />
            </Col>
            <Col span={2}></Col>
          </>
        )}
        {isTabletOrMobileDevice && (
          <>
            <Col span={24}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", width: "100%", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  pageSizeOptions: ["15", "25", "50", "100"],
                  defaultPageSize: take,
                  total: monthlyPlans.total,
                }}
                dataSource={monthlyPlans.data}
                loading={monthlyPlans.loading}
              />
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default MonthlyPlan;
